
import { NotificationService, NotificationType } from '../common/notifications';
import { defineComponent } from 'vue';
import { ServerManager } from '../common/servers';
import { JELLYFIN_SERVER_TYPE, ServerType } from '../api';
import { MediaServerTestResult } from '../api/interface';

interface ServerResolveResult {
    address: string;
    result: MediaServerTestResult;
}

export default defineComponent({
    emits: ['login-complete'],
    props: {
        serverManager: {
            required: true,
            type: ServerManager,
        },
    },
    data: function () {
        return {
            username: '',
            password: '',
            serverAddress: '',
            loginSuccess: false,
            serverTestMessage: null as string | null,
            serverTestSuccess: false,
            serverTestTesting: false,
            serverTestAddress: '',
            serverType: JELLYFIN_SERVER_TYPE as ServerType,
        };
    },
    methods: {
        async login(): Promise<void> {
            try {
                const server = await this.serverManager.connect(
                    this.serverType,
                    this.serverAddress,
                    this.username,
                    this.password
                );
                this.loginSuccess = true;
                NotificationService.notify(
                    'Successfully logged in',
                    NotificationType.Success
                );
                this.$emit('login-complete', server.serverId());
            } catch (e) {
                console.error(e);
                NotificationService.notify(
                    'Failed to authenticate. Username or password incorrect',
                    NotificationType.Error
                );
            }
        },
        async resolveServerAddress(
            address: string
        ): Promise<ServerResolveResult> {
            const addressesToTry = [address];
            if (!address.includes('://')) {
                addressesToTry.push('https://' + address.trim());
                addressesToTry.push('http://' + address.trim());
            }
            for (const address of addressesToTry) {
                this.serverTestAddress = address.trim();
                const test = await this.serverManager.test(
                    this.serverType,
                    this.serverTestAddress
                );
                if (test !== MediaServerTestResult.NoServer) {
                    return { address: this.serverTestAddress, result: test };
                }
            }
            return {
                address,
                result: MediaServerTestResult.NoServer,
            };
        },
        async testServerAddress(): Promise<void> {
            this.serverTestTesting = true;
            const resolve = await this.resolveServerAddress(this.serverAddress);
            if (resolve.result === MediaServerTestResult.Success) {
                this.serverAddress = resolve.address;
                this.serverTestSuccess = true;
                this.serverTestMessage = `Server found: ${resolve.address}`;
            } else if (resolve.result === MediaServerTestResult.InvalidServer) {
                this.serverTestSuccess = false;
                this.serverTestMessage = `Not a valid server: ${resolve.address}`;
            } else if (resolve.result === MediaServerTestResult.NoServer) {
                this.serverTestSuccess = false;
                this.serverTestMessage = `Could not connect to server: ${resolve.address}`;
            }
            this.serverTestTesting = false;
        },
    },
});
